<template>
    <div>
        <div class="form-info">
            <div class="form-row">
                <div class="form-label">
                    <label>交付是否完成</label>
                </div>
                <div class="form-value">
                    <div class="value" v-if="voucher.deliverFinished">是</div>
                    <div class="value" v-else>否</div>
                </div>
            </div>
            <div class="form-row" v-if="tradeVoucherType == 2">
                <div class="form-label">
                    <label>履约是否完成</label>
                </div>
                <div class="form-value">
                    <div class="value" v-if="voucher.fullfilled">是</div>
                    <div class="value" v-else>否</div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>验收是否完成</label>
                </div>
                <div class="form-value">
                    <div class="value" v-if="voucher.checked">是</div>
                    <div class="value" v-else>否</div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>是否关闭</label>
                </div>
                <div class="form-value">
                    <div class="value" v-if="voucher.closed">是</div>
                    <div class="value" v-else>否</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils} from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import tradeApi from '../../api/trade'
    export default{
        name: 'swb-trade-voucher-deliver-info',
        desc: '交易单-交付信息',
        props: ["tradeId", 'okText', 'tradeVoucherType'],
        data: function () {
            return {
                voucher: {}
            }
        },
        created: function () {
            this.getVoucherDetails(this.tradeId);
        },
        methods: {
            getVoucherDetails: function (id) {
                let self = this;
                let postData = {};
                postData.id = id;
                //
                let msgBoxDlg = MsgBox.loading();
                tradeApi.getTradeVoucherInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        self.voucher = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getDlgResult: function () {
                let result = {};
                let reminderFlag = "";
                if(this.okText == "关闭交易") {
                    if(!this.voucher.checked) {
                        reminderFlag = "验收未完成确定要执行该操作吗？";
                    } else {
                        reminderFlag = "确定要执行该操作吗？";
                    }
                } else {
                    reminderFlag = "确定要执行该操作吗？";
                }
                result.type = "info";
                result.data = this.voucher;
                result.message = reminderFlag;
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/tradeVoucher/TradeVoucherDeliverInfo.vue